export default {
    "maps": {
        path: "/auth/profile/maps",
    },
    "dashboard": {
        path: "/auth/dashboard",
    },
}